// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import fi from './locales/fi.json';
import store from './store';
import './assets/styles.css';

const messages = {
  en,
  fi
};

const i18n = createI18n({
  locale: 'fi', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
});

const app = createApp(App);
const API_URL = 'https://api-weblungi.raumanenergia.net/api';
app.config.globalProperties.$url = API_URL;
router.apiUrl = API_URL;

app.use(router);
app.use(i18n);
app.use(store)
app.mount('#app');